module.exports = __webpack_public_path__ + "media/images/products/retailers-customised-6-sample03-03bf41c0b5c157538d080ca15f321e0d.jpg";